export const FEEDBACKS_EMPTY_TITLE = 'Отзывов пока нет';
export const FEEDBACKS_EMPTY_TEXT =
  'Ваш отзыв поможет другим пользователям принять решение';
export const FEEDBACKS_EMPTY_BUTTON = 'Оставить отзыв';
